// tslint:disable: max-line-length
import React, { useEffect, useState } from 'react';
import Block from 'lqa-ui/lib/Components/Block';
import ChartTrend from 'lqa-ui/lib/Applications/Admin/Components/ChartTrend';
import AccessDenied from '../AccessDenied';
import Icon from 'lqa-ui/lib/Components/Icon';
import './styles.scss';
import { getItem, setItem } from '../../utils/localStorage';
import {
  UploadFileRestriction,
  assessments as assessmentApi,
  benchmarkCustom,
  getImproveOpportunities,
  hotelScoresByDepartment,
  lqaCustomCompset,
  CompetetingHotels,
  overAllScoreAPI,
  overallScore,
  departmentName,
} from './apiCaller';
import LoadingContent from 'lqa-ui/lib/Components/LoadingContent/index';
import { useLocation, useNavigate } from 'react-router-dom';
import { round, reverse } from 'lodash';
import { useProducedState } from '../../hooks/useProducedState';
import {
  getComparedToAverageClassStyle,
  getComparedToClassStyle,
} from '../../helpers/charts';
import { StandardPerformaceSelector } from '../../components/commons/StandardPerformanceSelector/standardPerformanceSelector';
import '../../style/main.scss';
import HotelAssessmentSelection from '../../components/commons/Header/HotelAssessmentSelection';
import { getTrendScore } from '../../components/TrendingScores/apiCaller';
import StepSlider from '../../components/commons/StepSlider/StepSlider';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { showErrorMessage } from '../../helpers/showMessage';
import { DEFAULT_VIEW } from '../../utils/constants';
import info1 from '../../../www/assets/svg/info1.svg';
import { isUnauthorized } from '../../utils/common';
import PendingAssessment from '../commons/PendingAssessment';
import {
  getBrandAndHotelData,
  gethasAssessment,
} from '../../helpers/handleBrandAndHotelData';
import { AppHeader } from '../../app/common/sharedComponents/AppHeader';
import { useTranslation } from 'react-i18next';
import {
  DashboardContainer,
  ContentArea,
  SubTitleWrapper,
  SubTitleTextContainer,
  CompetitorBottomSheetContainer,
  BottomSheetWrapper,
  BottomSheetHeaderBlock,
} from './Dashboard.styled';
import { Headline3, Headline6 } from '../../app/common/typography';
import { MissedStandardSimulator } from '../../app/dashboard/components/MissedStandardSimulator';
import { ISimulateButtonList } from 'src/app/@types/simulateButtons';
import { BottomSheet } from '../../app/common/sharedComponents/BottomSheet';
import { Headline4 } from '../../app/common/typography';
import { UserTypeEnum } from '../../app/common/enum/generic';
import {
  GaugeGraphsSlider,
  IOverallScore,
} from './GaugeGraphsSlider';
import { getFeatureFlags } from '../../app/common/requets/getFeatureFlags';

const nth = (d) => {
  if (d > 3 && d < 21) {
    return 'th';
  }
  switch (d % 10) {
    case 1:
      return 'st';
    case 2:
      return 'nd';
    case 3:
      return 'rd';
    default:
      return 'th';
  }
};

const Dashboard = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const l: any = { ...location };
  const { state } = l;
  setItem('isFormData', false);
  const { t } = useTranslation();
  const userData = getItem('user');
  const isViewer =
    userData && userData.user && userData.user.userType === UserTypeEnum.noData;
  const missedStandardHandler = () => {
    navigate('/missedStandard', { state: { selectedCompset } });
  };
  const [isLoading, setIsLoading] = useState<boolean | undefined>(false);
  const [scoreTrend, setScoreTrend] = useState<any>([]);
  const [benchmarkingScores, setBenchmarkingScores] = useState<any[]>([]);
  const [selectedHotel, setSelectedHotel] = useState(getItem('selectedHotel'));
  const [selectedClient, setSelectedClient] = useState(
    getItem('selectedClient')
  );
  const [sliderLoader, setSliderLoader] = useState(false);
  const [overAllScore, setOverallScore] = useState<IOverallScore[]>([]);
  const [missedStandardOverall, setMissedStandardOverall] = useState<
    | {
      score: number;
      change: number;
      rankingPosition: number;
      rankingTotal: number;
      compSetAverageScore: number;
    }
    | undefined
  >(undefined);
  const [assessments, setAssessments] = useState<
    {
      stayStart: string;
      id: number;
    }[]
  >([]);
  const [
    isDepartmentScoreFetched,
    setIsDepartmentScoreFetched,
  ] = useState<boolean>(false);
  const [selectedAssessment, setSelectedAssessment] = useState<any>(undefined);
  const [result, setResult] = useState<any>([]);
  const [selected, produceSelected] = useProducedState<Record<number, boolean>>(
    {}
  );
  const [successfulValue, produceSelectedValue] = useProducedState<
    Record<number, number>
  >({});
  const brandId = getItem('selectedBrand');
  const defaultValues = DEFAULT_VIEW.find((o: any) => o.brandId === brandId);
  const initialStandard =
    (state && state.standard) ||
    (defaultValues && defaultValues.defaultCustomScoreNumber) ||
    'LQA';
  const [standard, setStandard] = useState(initialStandard);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [performanceClassification, setPerformaceClassification] = useState('');
  const [departmentUser, setDepartmentUser] = useState<any>(undefined);
  const [userType, setUserType] = useState(
    userData && userData.user && userData.user.userType
  );
  const [compsetData, setCompsetData] = useState<any>([]);
  const [selectedCompset, setSelectedCompset] = useState<number>(0);
  const [selectedCompsetName, setSelectedCompsetName] = useState('LQA Compset');
  const [open, setOpen] = useState(false);
  const [competitorList, setCompetitorList] = useState<any>([]);
  const [deptName, setDeptName] = useState('');
  const [hasAssessment, setHasAssessment] = useState(gethasAssessment());
  const allHotels = getBrandAndHotelData();

  const getDefaultBenchmark = (assessmentsD) => assessmentsD.map(() => ({}));

  const handleIndexChange = (index) => {
    setCurrentIndex(index);
  };

  const handleInitialIndex = () => {
    const assD = [...assessments];
    reverse(assD);
    const index = assD.findIndex((o) => o.stayStart === selectedAssessment);
    setCurrentIndex(index);
  };

  const [simulateButtonList, setSimulateButtonList] = useState<
    ISimulateButtonList[]
  >([
    {
      title: '5 Standards',
      count: 5,
      selected: false,
    },
    {
      title: '10 Standards',
      count: 10,
      selected: false,
    },
    {
      title: '20 Standards',
      count: 20,
      selected: false,
    },
  ]);

  const benchmarkingHandler = () => {
    navigate(`/benchmarking`, {
      state: {
        selectedAssessment,
        hotelId: selectedHotel,
        brandId: getItem('selectedBrand'),
        selectedCompset,
        compsetData,
        selectedCompsetName,
        standard,
      },
    });
  };

  const trendingScoresHandler = () => {
    navigate(`/trendingScores`, {
      state: {
        scoreTrend,
        selectedAssessment,
        hotelId: selectedHotel,
        brandId: getItem('selectedBrand'),
        selectedCompset,
        compsetData,
        selectedCompsetName,
        standard,
      },
    });
  };

  const CompetitorListHandler = () => {
    return (
      <BottomSheetWrapper>
        <BottomSheet
          isOpen={open}
          onClose={() => setOpen(false)}
          title={`${competitorList && competitorList.length} Competitors`}
        >
          <BottomSheetHeaderBlock>
            <Headline4 color="eerieBlack">
              {t('COMMON.MY_AUDIT.LABELS.HOTELCAP')}
            </Headline4>
          </BottomSheetHeaderBlock>
          <CompetitorBottomSheetContainer>
            <div className="centered-container">
              {competitorList &&
                competitorList.length &&
                competitorList.map((hotel, index) => {
                  return (
                    <div
                      key={hotel.name}
                      className={`w-98 p-10 ${index % 2 === 0 ? 'background-f7f8f8' : ''
                        }`}
                    >
                      {hotel.name}
                    </div>
                  );
                })}
            </div>
          </CompetitorBottomSheetContainer>
        </BottomSheet>
      </BottomSheetWrapper>
    );
  };

  useEffect(() => {
    if (userData.user && userData.user.accessType) {
      getFeatureFlags();
      setUserType(userData.user.accessType);
    }
  }, []);

  useEffect(() => {
    UploadFileRestriction()
      .then((res) => {
        setItem('actionPlanFileTypes', res.actionPlanFileUploadAcceptTypes);
        setItem('actionPlanFileSize', res.actionPlanFileUploadMaxSizeBytes);
        setItem(
          'selfAssessmentFileSize',
          res.selfAssessmentFileUploadMaxSizeBytes
        );
      })
      .catch((error) => {
        showErrorMessage(
          "Couldn't Load Restriction settings",
          !isUnauthorized(error)
        );
      });

    if (userType !== 'full' && userData.user && hasAssessment) {
      departmentName()
        .then((res) => {
          if (
            userData &&
            userData.user &&
            userData.user.userType === 'department' &&
            res.length === 1
          ) {
            res.map((depts, i) => {
              setDeptName((dep) => dep + depts.value);
            });
          }
          if (
            userData &&
            userData.user &&
            userData.user.userType === 'subDepartment' &&
            res &&
            res.length > 0
          ) {
            res.map((depts, i) => {
              setDeptName(
                (dep) =>
                  dep +
                  depts.value.toLowerCase() +
                  `${i !== res.length - 1 ? '/ ' : ''}`
              );
            });
          }
        })
        .catch((err) => {
          showErrorMessage(
            'Unable to get Department Name',
            !isUnauthorized(err)
          );
        });
    }
  }, []);

  const handleUpdateSelectedCompsetByHotel = (
    compsetByHotel,
    selectedCompsetbyHotel,
    filteredResponse
  ) => {
    if (!compsetByHotel && filteredResponse.length > 1) {
      setItem('selectedCompset', 1);
      setSelectedCompset(1);
      return [
        ...selectedCompsetbyHotel,
        {
          hotelId: selectedHotel,
          selectedCompset: 1,
        },
      ];
    } else if (!compsetByHotel && filteredResponse.length === 1) {
      setItem('selectedCompset', 0);
      setSelectedCompset(0);
      return [
        ...selectedCompsetbyHotel,
        {
          hotelId: selectedHotel,
          selectedCompset: 0,
        },
      ];
    }
    setItem('selectedCompset', compsetByHotel.selectedCompset);
    setSelectedCompset(compsetByHotel.selectedCompset);
    return selectedCompsetbyHotel.map((item) =>
      item.hotelId === selectedHotel
        ? { ...item, selectedCompset: compsetByHotel.selectedCompset }
        : item
    );
  };

  useEffect(() => {
    if (userData && userData.user && selectedHotel && hasAssessment) {
      const selectedCompsetbyHotel = getItem('selectedCompsetbyHotel') || [];
      lqaCustomCompset().then((res) => {
        if (res) {
          const FilteredResponse = res.map((item) => {
            return {
              ...item,
              compSetName: item.compSetName
                .replace(' Customised Competitor Set', '')
                .replace(' Customized Competitor Set', ''),
            };
          });
          FilteredResponse.push({
            compSetName: 'LQA Compset',
            compSetNumber: 0,
          });
          setCompsetData(FilteredResponse);
          if (selectedCompsetbyHotel.length > 0) {
            const compsetByHotel = selectedCompsetbyHotel.find(
              (item) => item.hotelId === selectedHotel
            );
            const updatedItems = handleUpdateSelectedCompsetByHotel(
              compsetByHotel,
              selectedCompsetbyHotel,
              FilteredResponse
            );
            setItem('selectedCompsetbyHotel', JSON.stringify(updatedItems));
          } else {
            if (FilteredResponse.length <= 1) {
              setItem('selectedCompset', 0);
              setItem('selectedCompsetbyHotel', [
                {
                  hotelId: selectedHotel,
                  selectedCompset: 0,
                },
              ]);
            } else {
              setItem('selectedCompsetbyHotel', [
                {
                  hotelId: selectedHotel,
                  selectedCompset: 1,
                },
              ]);
              setItem('selectedCompset', 1);
              setSelectedCompset(1);
            }
          }
        }
      });
    }
  }, [selectedHotel, selectedClient, hasAssessment]);

  useEffect(() => {
    setPerformaceClassification('all');
    const compSet = getItem('selectedCompset') || 0;
    setSelectedCompset(compSet);
    if (selectedAssessment && compSet >= 0) {
      setIsLoading(true);
      Promise.all([
        overAllScoreAPI(selectedAssessment, selectedCompset),
        getTrendScore('LQA', selectedCompset),
        getImproveOpportunities(selectedAssessment),
      ])
        .then((res) => {
          setOverallScore(res[0]);
          setScoreTrend(res[1]);
          setResult(res[2]);
        })
        .catch((error) => {
          showErrorMessage('Something went wrong', !isUnauthorized(error));
        })
        .finally(() => {
          setIsLoading(false);
        });
      overallScore(selectedAssessment, selectedCompset)
        .then((res) => setMissedStandardOverall(res))
        .catch((error) => {
          showErrorMessage(
            "Couldn't fetch OverallScore",
            !isUnauthorized(error)
          );
        });
      const assD = [...assessments];
      reverse(assD);
      const index = assD.findIndex((o) => o.stayStart === selectedAssessment);
      setCurrentIndex(index);
    }
  }, [selectedAssessment, selectedCompset]);

  useEffect(() => {
    if (selectedCompset && compsetData && compsetData.length) {
      const compset = compsetData.find(
        // tslint:disable-next-line:triple-equals
        (o) => o.compSetNumber.toString() == selectedCompset
      );
      if (compset) {
        setSelectedCompsetName(compset.compSetName);
      }
    }
    if (
      selectedCompset &&
      selectedAssessment &&
      userData &&
      userData.user &&
      hasAssessment
    ) {
      CompetetingHotels(selectedCompset, selectedAssessment)
        .then((res) => {
          setCompetitorList(res);
        })
        .catch((err) => {
          showErrorMessage(
            'Error Occurred While getting Competitor List',
            !isUnauthorized(err)
          );
        });
    }
  }, [selectedCompset, selectedAssessment, hasAssessment]);

  useEffect(() => {
    setBenchmarkingScores([]);
    if (standard !== 'LQA') {
      setPerformaceClassification('all');
      benchmarkCustom(
        standard,
        selectedAssessment,
        setBenchmarkingScores,
        benchmarkingScores,
        setSliderLoader,
        assessments,
        performanceClassification
      ).then((res) => { });
      if (
        !isDepartmentScoreFetched &&
        selectedAssessment &&
        selectedHotel &&
        hasAssessment
      ) {
        hotelScoresByDepartment(
          assessments,
          selectedAssessment,
          setBenchmarkingScores,
          benchmarkingScores,
          setSliderLoader,
          setDepartmentUser,
          selectedCompset,
          performanceClassification
        ).then(() => {
          setIsDepartmentScoreFetched(true);
        });
      }
    } else {
      if (selectedAssessment && selectedHotel && hasAssessment) {
        hotelScoresByDepartment(
          assessments,
          selectedAssessment,
          setBenchmarkingScores,
          benchmarkingScores,
          setSliderLoader,
          setDepartmentUser,
          selectedCompset,
          performanceClassification
        ).then((res) => {
          setIsDepartmentScoreFetched(true);
        });
      }
    }
  }, [
    standard,
    assessments,
    performanceClassification,
    selectedCompset,
    hasAssessment,
  ]);

  useEffect(() => {
    if (selectedHotel) {
      setIsLoading(true);
      assessmentApi()
        .then((response) => {
          setAssessments(response);
          setBenchmarkingScores(getDefaultBenchmark(response));
          produceSelected((draft) => {
            Object.keys(draft).map((key, index) => {
              draft[key] = false;
            });
          });
          produceSelectedValue((d) => {
            Object.keys(d).map((key, index) => {
              d[key] = undefined;
            });
          });

          let selectedAssessmentIfAny;

          if (state && state.selectedAssessment) {
            selectedAssessmentIfAny = response.find(
              (bK) => bK.stayStart === state.selectedAssessment
            );
          }
          const assess = response.find(
            (o) => o.stayStart === getItem('selectedAssessmentDate')
          )
            ? getItem('selectedAssessmentDate')
            : undefined;
          setSelectedAssessment(
            assess
              ? assess
              : selectedAssessmentIfAny
                ? selectedAssessmentIfAny.stayStart
                : response[0].stayStart
          );
          setItem('selectedAssessmentId', response[0].id);
          setItem('templateId', response[0].templateId);
          setStandard(initialStandard);
        })
        .catch(() => {})
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [selectedHotel, selectedClient]);

  const originalScore = missedStandardOverall ? missedStandardOverall.score : 0;
  const Stats = result.stats ? result.stats : [];
  const calculatedPercentages = Stats.map((o) => {
    return (o.met / o.total) * 100;
  });

  const percentage =
    Math.round(
      (calculatedPercentages.reduce((acc, o) => acc + o, 0) /
        calculatedPercentages.length) *
      10
    ) / 10;
  const statsClone = JSON.parse(JSON.stringify(Stats));
  // tslint:disable-next-line:no-unused-expression
  result &&
    result.standards &&
    result.standards.forEach((isMaximised, i) => {
      if (selected[i]) {
        const missedStandard = result.standards[i];
        const missedServices = missedStandard.missedServiceCodes
          ? missedStandard.missedServiceCodes
          : [];
        missedServices.forEach((benchmarkDepartmentId) => {
          const statRow = statsClone.find(
            (o) => o.benchmarkDepartmentId === benchmarkDepartmentId
          );
          if (statRow) {
            statRow.met++;
          }
        });
      }
    });
  const simulatedPercentage = statsClone.map((o) => {
    return (o.met / o.total) * 100;
  });

  const simpercentage =
    Math.round(
      (simulatedPercentage.reduce((acc, o) => acc + o, 0) /
        simulatedPercentage.length) *
      10
    ) / 10;
  const changePercentage = simpercentage - percentage;

  const overallScoreD = originalScore;
  let displayScore = round(
    parseFloat(overallScoreD + changePercentage + ''),
    2
  );
  if (displayScore > 100) {
    displayScore = 100; // lmiting to 100% beacuse of bonus question.
  }
  const standards =
    result &&
    result.standards &&
    result.standards.map((row, index) => {
      return {
        name: row.standard,
        emulating: selected[index],
        opportunities: row.total,
        successful: successfulValue[index]
          ? successfulValue[index]
          : row.total - row.missedCount,
        missedCount: row.missedCount,
        onClick () {
          produceSelected((draft) => {
            draft[index] = !draft[index];
          });
          produceSelectedValue((d) => {
            if (!selected[index]) {
              d[index] = this.opportunities;
            } else {
              d[index] = this.opportunities - this.missedCount;
            }
          });
        },
      };
    });

  function handleSimulateButtonClick (
    buttonIndex: number,
    missedStandardsCounts: number
  ) {
    setSimulateButtonList(
      simulateButtonList.map((button, index) => {
        if (index === buttonIndex) {
          return { ...button, selected: true };
        }
        return { ...button, selected: false };
      })
    );
    produceSelected((draft) => {
      Array.from({ length: missedStandardsCounts }).forEach((_, i) => {
        draft[i] = true;
      });
      Array.from({ length: 20 - missedStandardsCounts }).forEach((_, i) => {
        draft[missedStandardsCounts + i] = false;
      });
    });
    produceSelectedValue((d) => {
      const startIndex = missedStandardsCounts - 5;
      Array.from({ length: missedStandardsCounts }).forEach((_, i) => {
        d[i] = selected[startIndex]
          ? standards[i].total - standards[i].missedCount
          : standards[i].total;
      });
    });
  }

  function handleResetButtonClick () {
    setSimulateButtonList((prevList) =>
      prevList.map((button) => ({
        ...button,
        selected: false,
      }))
    );
    const resetMissedStandardIndices = Array.from({ length: 20 }, (_, i) => i);
    produceSelected((draft) => {
      resetMissedStandardIndices.forEach((standardIndex) => {
        draft[standardIndex] = false;
      });
    });

    produceSelectedValue((draft) => {
      resetMissedStandardIndices.forEach((standardIndex) => {
        draft[standardIndex] =
          standards[standardIndex].total - standards[standardIndex].missedCount;
      });
    });
  }

  if (!userData || !userData.user || !userData.user.brands || allHotels <= 0) {
    return (
      <>
        <AccessDenied tabname="Dashboard" />
      </>
    );
  }

  if (!hasAssessment) {
    return (
      <>
        <PendingAssessment
          assessments={assessments}
          setAssessments={setAssessments}
          selectedHotel={selectedHotel}
          setSelectedHotel={setSelectedHotel}
          selectedClient={selectedClient}
          setSelectedClient={setSelectedClient}
          selectedAssessment={selectedAssessment}
          setSelectedAssessment={setSelectedAssessment}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          lqaCompset={compsetData}
          selectedCompset={selectedCompset}
          setSelectedCompset={setSelectedCompset}
          hasAssessment={hasAssessment}
          setHasAssessment={setHasAssessment}
        />
      </>
    );
  }
  return (
    <DashboardContainer>
      {CompetitorListHandler()}
      <div className="header">
        <AppHeader hasBackButton={false} title={t('COMMON.DASHBOARD.TITLE')} />
        <HotelAssessmentSelection
          assessments={assessments}
          setAssessments={setAssessments}
          selectedHotel={selectedHotel}
          setSelectedHotel={setSelectedHotel}
          selectedClient={selectedClient}
          setSelectedClient={setSelectedClient}
          selectedAssessment={selectedAssessment}
          setSelectedAssessment={setSelectedAssessment}
          isSelectDate={true}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          lqaCompset={compsetData}
          selectedCompset={selectedCompset}
          setSelectedCompset={setSelectedCompset}
          hasAssessment={hasAssessment}
          setHasAssessment={setHasAssessment}
        />
      </div>

      {isLoading ||
        !overAllScore ||
        overAllScore.length <= 0 ||
        !result ||
        !selectedAssessment ||
        !missedStandardOverall ? (
        <ContentArea>
          <div className="box-shadow d-block">
            <div className="m-10 mb-20">
              <Skeleton
                containerClassName="flex-1"
                height={230}
                borderRadius={5}
              />

              <div className="row-separater-skeleton mb-10">
                <Skeleton width={150} height={30} borderRadius={5} />
                <Skeleton width={50} height={25} borderRadius={5} />
              </div>
              <div className="row-separater-skeleton pl-15 pr-15 mb-10">
                <Skeleton width={150} height={50} borderRadius={5} />
                <Skeleton width={150} height={50} borderRadius={5} />
              </div>
              <div className="pl-15 pr-15">
                <Skeleton
                  containerClassName="flex-1"
                  height={300}
                  borderRadius={5}
                />
              </div>
            </div>
          </div>
        </ContentArea>
      ) : (
        <ContentArea>
          <div>
            {isViewer ? (
              <div className="z-index-100">
                {' '}
                <Icon kind="lock" height={40} width={40} />
              </div>
            ) : (
              <></>
            )}
            <div className={isViewer ? 'blur' : ''}>
              <div className="d-block ml-10 mr-10">
                  <div className="block theme-default box-shadow d-block m-7">
                    <GaugeGraphsSlider overallScores={overAllScore} />
                  </div>
                <div className="d-inline-block f-left w-80 mt-1-5rem mb-1-5rem">
                  <span className="color-071C3E m-0 fw-600 f-22 lh-28 capitalize">{`Benchmarking${deptName !== '' ? '- ' + deptName : ''
                    }`}</span>
                </div>
                <div className="d-inline-block w-20 mt-1-5rem mb-1-5rem text-right">
                  <span
                    className="color-007AFF fw-600 f-12 lh-16"
                    onClick={benchmarkingHandler}
                  >
                    See All
                  </span>
                </div>
              </div>
              <Block className="box-shadow d-block m-7">
                {hasAssessment && (
                  <StandardPerformaceSelector
                    standard={standard}
                    setStandard={setStandard}
                    selectedHotel={selectedHotel}
                    selectedClient={selectedClient}
                    selectedAssessment={selectedAssessment}
                    setPerformaceClassification={setPerformaceClassification}
                    performanceClassification={performanceClassification}
                    isSelf={false}
                  />
                )}

                <div>
                  {benchmarkingScores &&
                    benchmarkingScores.length > 0 &&
                    benchmarkingScores[currentIndex] &&
                    benchmarkingScores[currentIndex].scores &&
                    benchmarkingScores[currentIndex].scores.length ? (
                    <ChartTrend
                      data={benchmarkingScores[currentIndex].scores}
                    />
                  ) : sliderLoader ? (
                    <></>
                  ) : (
                    <div style={{ height: '320px' }}>
                      <LoadingContent />
                    </div>
                  )}
                  {sliderLoader ? (
                    <>
                      <LoadingContent layout="flex" />
                      <span className="loader-text">
                        Waiting for other assessments ...
                      </span>
                    </>
                  ) : (
                    <StepSlider
                      onChange={handleIndexChange}
                      onAfterChange={handleInitialIndex}
                      currentIndex={currentIndex}
                      max={benchmarkingScores.length - 1}
                    />
                  )}
                  <div className="assessmentDiv">
                    <span className="fw-600 f-15 lh-19 color-1F1F1F">
                      Assessment:
                      <span className="fw-400 text-underline color-919191 pl-3">
                        {benchmarkingScores[currentIndex] &&
                          benchmarkingScores[currentIndex].selectedAss
                          ? benchmarkingScores[currentIndex].selectedAss
                          : '-'}
                      </span>
                    </span>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                      }}
                    >
                      <div className="fw-400 f-12 lh-15 color-919191 pt-5">
                        {selectedCompsetName}
                      </div>
                      <img src={info1} onClick={() => setOpen(true)} />
                    </div>
                  </div>
                </div>
              </Block>
              <div className="d-block m-10 black-border-1" />
              <div className="d-block ml-10 mr-10">
                <div className="d-inline-block f-left w-80 mt-1-5rem mb-1-5rem">
                  <span className="color-071C3E fw-600 f-22 lh-28 m-0 capitalize">{`Trending Scores${deptName !== '' ? '- ' + deptName : ''
                    }`}</span>
                </div>
                <div className="d-inline-block w-20 mt-1-5rem mb-1-5rem text-right">
                  <span
                    className="color-007AFF fw-600 f-12 lh-16"
                    onClick={trendingScoresHandler}
                  >
                    See All
                  </span>
                </div>
              </div>
              <Block className="box-shadow d-block m-7">
                {scoreTrend && scoreTrend.length > 0 && (
                  <ChartTrend
                    data={scoreTrend[0].scores}
                  />
                )}
              </Block>
              <div className="d-block m-10 black-border-1" />
              <SubTitleWrapper>
                <SubTitleTextContainer>
                  <Headline3>
                    {t('COMMON.DASHBOARD.IMPROVEMENT_OPPORTUNITIES')}
                  </Headline3>
                  <Headline6 color={'azure'} onClick={missedStandardHandler}>
                    {t('COMMON.DASHBOARD.SEE_ALL')}
                  </Headline6>
                </SubTitleTextContainer>
                <MissedStandardSimulator
                  percentage={displayScore}
                  handleSimulateButtonClick={handleSimulateButtonClick}
                  simulateButtonList={simulateButtonList}
                  handleResetButtonClick={handleResetButtonClick}
                  intent={getComparedToAverageClassStyle(
                    displayScore - missedStandardOverall.compSetAverageScore
                  )}
                  change={changePercentage}
                  changeIntent={getComparedToClassStyle(changePercentage)}
                />
              </SubTitleWrapper>
            </div>
          </div>
        </ContentArea>
      )}
    </DashboardContainer>
  );
};

export default Dashboard;
